<template>
  <auth-shell title="دخول المعلمين" subtitle="اسم المستخدم وكلمة المرور تجدها في رسالة المدرسة.">
    <div class="auth-alert bad" v-if="error"><i class="fa fa-exclamation-circle"></i><span>{{ error }}</span></div>

    <label class="auth-field" for="t-username">
      <span class="auth-label">اسم المستخدم</span>
      <span class="auth-input">
        <i class="fa fa-user-o"></i>
        <input id="t-username" type="text" v-model="username" v-on:keyup.enter="login()" autocomplete="username" placeholder="اسم المستخدم">
      </span>
    </label>

    <label class="auth-field" for="t-password">
      <span class="auth-label">كلمة المرور</span>
      <span class="auth-input">
        <i class="fa fa-lock"></i>
        <input id="t-password" :type="show ? 'text' : 'password'" v-model="password" v-on:keyup.enter="login()" autocomplete="current-password" placeholder="كلمة المرور">
        <button type="button" class="auth-eye" @click="show = !show" :aria-label="show ? 'إخفاء كلمة المرور' : 'إظهار كلمة المرور'">
          <i :class="show ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </button>
      </span>
    </label>

    <button class="auth-btn" @click="login()">
      تسجيل الدخول <i class="fa fa-arrow-left"></i>
    </button>

    <p class="auth-alt">
      لست معلماً؟
      <a href="javascript:;" @click="$router.push('/login')">دخول المدرسة والمشرفين</a>
    </p>
  </auth-shell>
</template>

<script>
import AuthShell from '../components/AuthShell.vue';

export default {
    components: { AuthShell },
    created(){
        if(window.location.href.includes("/j/")){
            var d = atob(window.location.href.split("/j/")[1])
            this.username = d.split(",")[0]
            this.password = d.split(",")[1]
            this.login()
        }
    },
    data(){
        return {
            username: "",
            password: "",
            error: null,
            show: false
        }
    },
    methods: {
        login(){
            var g = this;
            g.error = null;
            $.post(api + '/teacher/auth/login', {
                username: g.username,
                password: g.password
            }).then(function(r){
                if(r.status != 100){
                    g.error = r.response
                }else{
                    localStorage.setItem("teacher", JSON.stringify(r.response))
                    window.location = '/_xteacher'
                }
            }).fail(function(){
                g.error = "حدث مشكلة في الاتصال"
            })
        }
    }
}
</script>
